/**
 * ROLES
 */

export const Role = {
  ADMIN: 'admin',
  OPEC: 'opec',
  ENG: 'eng',
  PROG: 'prog',
  PROMO: 'promo',
  JORN: 'jorn',
  CEDOC: 'cedoc',
  MKT: 'mkt',
  EXIB: 'exib',
  EXEC: 'exec',
  SYSTEM: 'system',
};

export const Roles = [
  { id: Role.ADMIN, label: 'Administrador' },
  { id: Role.OPEC, label: 'Opec' },
  { id: Role.ENG, label: 'Engenharia' },
  { id: Role.PROG, label: 'Programação' },
  { id: Role.PROMO, label: 'Produção' },
  { id: Role.JORN, label: 'Jornalismo' },
  { id: Role.CEDOC, label: 'Cedoc' },
  { id: Role.MKT, label: 'Marketing' },
  { id: Role.EXIB, label: 'Exibição' },
  { id: Role.EXEC, label: 'Executivo' },
  { id: Role.SYSTEM, label: 'System' },
];
export const Categoria = {
  COMERCIAL: 'comercial',
  CHAMADA: 'chamada',
  OPTATIVO: 'optativo',
  PATROCINIO: 'patrocinio',
  OUTRAS: 'outras',
};

export const CategoriaComercial = {
  COMERCIAL: 'comercial',
  PATROCINIO: 'patrocinio',
  PROMO: 'promo',
  BASE: 'base',
};
export const Categorias = [
  { id: Categoria.COMERCIAL, label: 'comercial' },
  { id: Categoria.CHAMADA, label: 'chamada' },
  { id: Categoria.OUTRAS, label: 'OUTRAS' },
];

/**
 * SETORES 'opec','engenharia','promo','hub','programacao'
 */
export const Setor = {
  OPEC: 'opec',
  ENGENHARIA: 'engenharia',
  PROMO: 'promo',
  HUB: 'hub',
  PROGRAMACAO: 'programacao',
  JORNALISMO: 'jornalismo',
  CEDOC: 'cedoc',
  MARKETING: 'marketing',
  EXECUTIVO: 'executivo',
};

export const Setores = [
  {
    id: Setor.OPEC,
    label: 'Opec',
    role_reference: Role.OPEC,
  },
  {
    id: Setor.ENGENHARIA,
    label: 'Engenharia',
    role_reference: Role.ENG,
  },
  { id: Setor.PROMO, label: 'Promo', role_reference: Role.PROMO },
  { id: Setor.HUB, label: 'Hub', role_reference: Role.PROMO },
  {
    id: Setor.PROGRAMACAO,
    label: 'Programação',
    role_reference: Role.PROG,
  },
  { id: Setor.JORNALISMO, label: 'Jornalismo', role_reference: Role.JORN },
  { id: Setor.CEDOC, label: 'Cedoc', role_reference: Role.CEDOC },
  { id: Setor.MARKETING, label: 'Marketing', role_reference: Role.MKT },
  { id: Setor.EXECUTIVO, label: 'Executivo', role_reference: Role.EXEC },
];

/**
 * FILTROS CHAMADAS
 */

export const DataFilter = {
  setores: [
    { id: '', label: 'TODOS' },
    { id: 'hub', label: 'HUB' },
    { id: 'promo', label: 'PROMO' },
  ],
  tipos: [
    { id: 'chamada', label: 'Chamada' },
    { id: 'vinheta', label: 'Vinheta' },
    {
      id: 'promocional',
      label: 'Promocional',
    },
    {
      id: 'chpatrocinada',
      label: 'CH Patr.',
    },
    { id: 'apoio', label: 'Apoio' },
    { id: 'campanha', label: 'Campanha' },
    { id: 'campanhapatrocinada', label: 'CAMP Patr.' },
    { id: 'videopatrocinado', label: 'Video Patr.' },
    { id: 'programete', label: 'Programete' },
    { id: 'afinacao', label: 'Afinacao' },
  ],
  opec: [{ id: 'sim', label: 'CLAQUETES OPEC' }],
  pendenteeng: [{ id: 'pendenteeng', label: 'PENDENTE ENG' }],
};

/**
 * Avaliacaoeng: 'pendente','aprovado','reprovado','ressalva'
 */
export const Avaliacaoeng = {
  PENDENTE: 'pendente',
  APROVADO: 'aprovado',
  REPROVADO: 'reprovado',
  RESSALVA: 'ressalva',
};

/**
 * Status(chamada):
 */
export const Status = {
  EMPROCESSO: 'emprocesso',
  APROVACAO: 'aprovacao',
  APROVADO: 'aprovado',
  ENTREGUE: 'entregue',
  FINALIZADO: 'finalizado',
  ALTERACAO: 'alteracao',
};

export const StatusAssinatura = {
  PENDENTE: 'pendente',
  PROCESSADO: 'processado',
  NA: 'NA',
  ERRO: 'erro',
};

export const StatusGravacaoChamada = {
  ENVIANDOMIDIA: 'enviandomidia',
  ENVIADOMIDIA: 'enviadomidia',
  ENVIANDODADOS: 'enviandodados',
  ENVIADODADOS: 'enviadodados',
  PENDENTE: 'pendente',
  ERRO: 'erro',
  CONCLUIDO: 'concluido',
  DISPONIBILIZADA: 'disponibilizada',
};

export const Tipo = {
  CHAMADA: 'chamada',
  VINHETA: 'vinheta',
  PROMOCIONAL: 'promocional',
  CHPATROCINADA: 'chpatrocinada',
  APOIO: 'apoio',
  CAMPANHA: 'campanha',
  PROGRAMETE: 'programete',
  AFINACAO: 'afinacao',
  VIDEOPATROCINADO: 'videopatrocinado',
  CAMPANHAPATROCINADA: 'campanhapatrocinada',
};

export const DiasDaSemana = [
  {
    id: 1,
    pt: 'DOMINGO',
    eng: 'SUNDAY',
  },
  {
    id: 2,
    pt: 'SEGUNDA-FEIRA',
    eng: 'MONDAY',
  },
  {
    id: 3,
    pt: 'TERÇA-FEIRA',
    eng: 'TUESDAY',
  },
  {
    id: 4,
    pt: 'QUARTA-FEIRA',
    eng: 'WEDNESDAY',
  },
  {
    id: 5,
    pt: 'QUINTA-FEIRA',
    eng: 'THURSDAY',
  },
  {
    id: 6,
    pt: 'SEXTA-FEIRA',
    eng: 'FRIDAY',
  },
  {
    id: 7,
    pt: 'SÁBADO',
    eng: 'SATURDAY',
  },
];
// status baixa e caption criar
export const StatusSolicitacao = {
  EMPROCESSO: 'emprocesso',
  ENVIADA: 'enviada',
};
export const StatusConferencia = {
  PENDENTE: 'pendente',
  APROVADO: 'aprovado',
};

export const StatusAnuncioJornal = {
  EMPROCESSO: 'emprocesso',
  APROVACAO: 'aprovacao',
  ALTERACAO: 'alteracao',
  ENVIADO: 'enviado',
};

export const StatusCaption = {
  SEMCC: 'semcc',
  AUTOTRANSCREVER: 'autotranscrever',
  ENVIADAVI: 'enviadavi',
  EDICAO: 'edicao',
  EDITADA: 'editada',
  ENCAPSULAR: 'encapsular',
  ENCAPSULADA: 'encapsulada',
  ERRO: 'erro',
  NA: 'na',
};
export const StatusArquivo = {
  ERRO: 'erro',
  PROCESSADO: 'processado',
  SOLICITADO: 'solicitado',
  AUTORIZADO: 'autorizado',
  NA: 'NA',
};

export const StatusBaixa = {
  PENDENTE: 'pendente',
  PROCESSADO: 'processado',
  PROCESSANDO: 'processando',
  ERRO: 'erro',
  NA: 'na',
};

export const StatusPlanilhaValidos = {
  PENDENTE: 'pendente',
  PROCESSADO: 'processado',
  PROCESSANDO: 'processando',
  ERRO: 'erro',
  NA: 'na',
};
export const StatusWeb = {
  SEMWEB: 'semweb',
  CONVERTIDO: 'convertido',
};

export const StatusEnviaExibidor = {
  PENDENTE: 'pendente',
  ENVIANDOMIDIA: 'enviandomidia',
  ENVIADOMIDIA: 'enviadomidia',
  ENVIANDODADOS: 'enviandodados',
  CONCLUIDO: 'concluido',
  ERRO: 'erro',
  CMMEIXISTENTE: 'cmexistente',
  INGESTMANUAL: 'ingestmanual',
  DISPONIBILIZADA: 'disponibilizada',
};
export const StatusPreAvaliacao = {
  PENDENTE: 'pendente',
  APROVADO: 'aprovado',
  REPROVADO: 'reprovado',
  RESSALVA: 'ressalva',
  PROCESSANDO: 'processando',
  ERRO: 'erro',
  NA: 'na',
};

export const StatusDownload = {
  PENDENTE: 'pendente',
  EMANDAMENTO: 'emandamento',
  ENTREGUE: 'entregue',
  REENVIO: 'reenvio',
  INDISPONIVEL: 'indisponivel',
  ERRO: 'erro',
};

export const StatusRoteiro = {
  PENDENTE: 'pendente',
  CADASTRADO: 'cadastrado',
  ANALISADO: 'analisado',
  ERRO: 'erro',
};

export const LinhaRoteiroStatusGravacao = {
  GRAVADO: 'gravado',
  NAOGRAVADO: 'naogravado',
  EXIBREDE: 'exibrede',
  FADE: 'fade',
};

export const Classificacoes = [
  {
    value: 'livre',
    label: 'LIVRE',
  },
  {
    value: '10 anos',
    label: '10 anos',
  },
  {
    value: '12 anos',
    label: '12 anos',
  },
  {
    value: '14 anos',
    label: '14 anos',
  },
  {
    value: '16 anos',
    label: '16 anos',
  },
  {
    value: '18 anos',
    label: '18 anos',
  },
];

export const TipoSolicitacaoChamada = {
  JORNALISMO: 'jornalismo',
  PGMLINHA: 'pgmlinha',
  ESPECIAIS: 'especiais',
};

export const StatusRoteiroPromo = {
  EMPROCESSO: 'emprocesso',
  APROVACAO: 'aprovacao',
  LOCUCAO: 'locucao',
  FINALIZADO: 'finalizado',
};

export const StatusLocucao = {
  NA: 'NA',
  SOLICITADO: 'solicitado',
  GRAVADO: 'gravado',
};

export const StatusCriativo = {
  PENDENTE: 'pendente',
  RASCUNHO: 'rascunho',
  PROCESSADO: 'processado',
  ERRO: 'erro',
};

export const CategoriaPrograma = {
  OPTATIVO: 'optativo',
  JORNALISMO: 'jornalismo',
};

export const TipoSolicitacaoTelao = {
  PADRAO: 'padrao',
  OUTROFORMATO: 'outroformato',
  NOVACRIACAO: 'novacriacao',
  NA: 'NA',
};

export const TipoSolicitacaoDigital = [
  {
    value: 'CAMPANHA',
    label: 'CAMPANHA',
  },
  {
    value: 'PROMOCIONAL',
    label: 'PROMOCIONAL',
  },
  {
    value: 'PROJETO ESPECIAL',
    label: 'PROJETO ESPECIAL',
  },
  {
    value: 'G1',
    label: 'G1',
  },
  {
    value: 'EXCLUSIVO',
    label: 'EXCLUSIVO',
  },
  {
    value: 'BICHO DO PARANÁ',
    label: 'BICHO DO PARANÁ',
  },
  {
    value: 'ROCKET',
    label: 'ROCKET',
  },
  {
    value: 'HUB',
    label: 'HUB',
  },
];

export const Permissao = {
  AVALIADOR: 'avaliador',
  LOCUCAO: 'locucao',
  RELATORIOCOM: 'relatorio-comercial',
  RELATORIOPROD: 'relatorio-producao',
  RELATORIOOPTA: 'relatorio-optativo',
  CHVISUALIZADOR: 'chamada-visualizador',
  USUARIOEDITOR: 'usuario-editor',
  SOLPROMOOUTROS: 'solpromo-outros',
  OPERACAOREMOTA: 'operacaoremota',
  SOLICITACAO: 'solicitacao',
  PROGRAMAEDITOR: 'programa-editor',
  ORA: 'ora',
  INDICADORCOMERCIAL: 'indicador-comercial',
  CRIATIVOS: 'criativos',
};

export const FormatosOrientacaoExibOptions = [
  { id: 'primeirissima', label: 'Primeiríssima' },
  { id: 'breakexclusivo', label: 'Break Exclusivo' },
  { id: 'breakdeterminado', label: 'Break Determinado' },
  { id: 'ora', label: 'ORA' },
  { id: 'vhbloco', label: 'Vinheta de Bloco' },
  { id: 'tarjapatrocinada', label: 'Tarja Patrocinada' },
  { id: 'boletim', label: 'Boletim' },
  { id: 'insercoescombinadas', label: 'Inserções Combinadas' },
  { id: 'outros', label: 'Outras Orientações' },
];

export const FormatoOrientacaoExib = {
  PRIMEIRISSIMA: 'primeirissima',
  BREAKEXCLUSIVO: 'breakexclusivo',
  BREAKDETERMINADO: 'breakdeterminado',
  ORA: 'ora',
  VHBLOCO: 'vhbloco',
  TARJAPATROCINADA: 'tarjapatrocinada',
  BOLETIM: 'boletim',
  INSERCOESCOMBINADAS: 'insercoescombinadas',
  OUTROS: 'outros',
};
